import { Component } from '@angular/core';
import { MatDialog } from '@angular/material';
import { CrudService, CrudType, IApplicationResponse, ModulesBasedApiSuffix, ReusablePrimeNGTableFeatureService, RxjsService, addDefaultTableObjectProperties, onActionSubmittedUtil, prepareGetRequestHttpParams } from '@app/shared';
import { UserModuleApiSuffixModels } from '@modules/user/shared';
import { Module } from '@user/models';
import { PrimeNgTableVariablesModel } from '../../../../../shared/models/prime-ng-table-list-component-variables.model';
import { ModuleAddEditComponent } from './module-add-edit.component';

@Component({
  selector: 'app-module-list',
  templateUrl: './module-list.component.html',
})

export class ModuleListComponent extends PrimeNgTableVariablesModel {
  primengTableConfigProperties: any = {
    tableCaption: "Modules List",
    breadCrumbItems: [{ displayName: 'Internal Settings', relativeRouterUrl: '' },
    { displayName: 'Modules List', relativeRouterUrl: '' }],
    tableComponentConfigs: {
      tabsList: [
        {
          caption: 'Modules List',
          dataKey: 'moduleId',
          enableAction: true,
          enableScrollable: true,
          checkBox: true,
          enableStatusActiveAction: true,
          enableMultiDeleteActionBtn: true,
          enableRowDelete: true,
          columns: [
            { field: 'moduleName', header: 'Module', width: '150px' },
            { field: 'description', header: 'Description', width: '150px' },
            { field: 'sortOrder', header: 'Sort Order', width: '150px' },
            { field: 'createdDate', header: 'Created Date', width: '150px', isDate: true },
            { field: 'isActive', header: 'Status', width: '150px' },
          ],
          apiSuffixModel: UserModuleApiSuffixModels.MODULES,
          moduleName: ModulesBasedApiSuffix.IT_MANAGEMENT,
        }
      ]
    }
  }

  constructor(private rxjsService: RxjsService,
    private dialog: MatDialog,
    private reusablePrimeNGTableFeatureService: ReusablePrimeNGTableFeatureService,
    private crudService: CrudService) {
    super();
    this.primengTableConfigProperties = addDefaultTableObjectProperties(this.primengTableConfigProperties);
  }

  ngOnInit(): void {
    this.rxjsService.setGlobalLoaderProperty(false);
    this.getRequiredListData();
  }

  getRequiredListData(pageIndex?: string, pageSize?: string,
    otherParams?: object) {
    this.loading = true;
    this.crudService.get(
      ModulesBasedApiSuffix.IT_MANAGEMENT,
      UserModuleApiSuffixModels.MODULES,
      undefined,
      false, prepareGetRequestHttpParams(pageIndex, pageSize, otherParams), 1
    ).subscribe((response: IApplicationResponse) => {
      if (response.isSuccess && response.statusCode === 200 && response.resources) {
        this.dataList = response.resources;
        this.totalRecords = response.totalCount;
        this.rxjsService.setGlobalLoaderProperty(false);
      }
      this.loading = false;
    });
  }

  onCRUDRequested(type: CrudType | string, row?: object | any, searchObj?: any): void {
    switch (type) {
      case CrudType.CREATE:
        this.openAddEditPage();
        break;
      case CrudType.GET:
        this.getRequiredListData(row["pageIndex"], row["pageSize"], searchObj);
        break;
      case CrudType.EDIT:
        this.openAddEditPage(row);
        break;
      case CrudType.VIEW:
        this.openAddEditPage(row);
        break;
        break;
      case CrudType.DELETE:
        this.reusablePrimeNGTableFeatureService.openDynamicDeleteDialog(this.selectedTabIndex, this.selectedRows,
          this.primengTableConfigProperties, row)?.onClose?.subscribe((result) => {
            if (result) {
              this.selectedRows = [];
              this.getRequiredListData();
            }
          });
        break;
      case CrudType.STATUS_POPUP:
        this.reusablePrimeNGTableFeatureService.openDynamicChangeStatusDialog(this.selectedTabIndex,
          this.primengTableConfigProperties, row)?.onClose?.subscribe((result) => {
            if (!result) {
              this.dataList[searchObj].isActive = this.dataList[searchObj].isActive ? false : true;
            }
          });
        break;
    }
  }

  applyFilter(filterValue: string) {
    this.getRequiredListData('0', '10', { search: filterValue });
  }

  openAddEditPage(data?): void {
    if (!data) {
      data = new Module(data);
    }
    const dialogReff = this.dialog.open(ModuleAddEditComponent, { width: '450px', data: data, disableClose: true });
    dialogReff.afterClosed().subscribe(result => {
      if (!result) { this.getRequiredListData() }
    })
  }

  onActionSubmited(e) {
    onActionSubmittedUtil(e, this.onCRUDRequested.bind(this));
  }

  onChangeSelecedRows(e) {
    this.selectedRows = e;
  }
}
